import styled from 'styled-components';

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 1rem auto;
  max-width: 1000px;
  padding: 0 1rem;
  
  /* Tablet and smaller - stack vertically */
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    margin: 1rem auto;
  }
`;

export const GameBoxImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  object-position: center;
  display: block;
  border-radius: 12px;
  margin-left: 1rem;
  margin-right: 1rem;
  max-width: 600px;
  
  /* Gentle floating animation */
  animation: float 10s ease-in-out infinite;
  
  /* Dynamic glow effect */
  filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.3));
  
  @keyframes float {
    0%, 100% {
      transform: translateY(0px);
    }
    25% {
      transform: translateY(-6px);
    }
    50% {
      transform: translateY(-2px);
    }
    75% {
      transform: translateY(-8px);
    }
  }
  
  /* Hover effect for extra interactivity */
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-5px) scale(1.05);
    filter: drop-shadow(0 0 30px rgba(255, 255, 255, 0.5));
  }
`;

